import React from "react";
import { QRCodeSVG } from "qrcode.react";

/**
 * Build a UPI intent URL that any UPI app (GPay, PhonePe, Paytm, BHIM) will honor.
 * Docs: https://developers.google.com/pay/india/api/web/create-payment-method
 */
export const buildUpiUrl = ({ upiId, name, amount, note }) => {
  const params = new URLSearchParams();
  params.set("pa", upiId);
  if (name) params.set("pn", name);
  params.set("cu", "INR");
  if (amount && amount > 0) params.set("am", Number(amount).toFixed(2));
  if (note) params.set("tn", note.slice(0, 80));
  return `upi://pay?${params.toString()}`;
};

const UpiQRCode = ({ upiId, name = "", amount = 0, note = "", size = 220 }) => {
  if (!upiId) return null;
  const url = buildUpiUrl({ upiId, name, amount, note });

  return (
    <div className="inline-flex flex-col items-center" data-testid="upi-qr-block">
      <div className="p-3 bg-white rounded-xl border border-[#E2E8F0]">
        <QRCodeSVG
          value={url}
          size={size}
          level="M"
          bgColor="#FFFFFF"
          fgColor="#1E293B"
          data-testid="upi-qr-svg"
        />
      </div>
      <div className="mt-2 text-center">
        {name && <p className="font-heading font-semibold text-sm text-[#1E293B]">{name}</p>}
        <p className="text-xs text-slate-600 font-mono">{upiId}</p>
        {amount > 0 && (
          <p className="text-xs text-[#D97706] font-semibold mt-0.5">₹{Number(amount).toFixed(2)}</p>
        )}
      </div>
    </div>
  );
};

export default UpiQRCode;
